import * as actionConsts from './actions';
import update from 'react/lib/update';

export const initState = {
  tasks: []
}


export default (state = initState, action) => {
  switch (action.type) {
    case actionConsts.GET_WORKPLACE_TASKS_SUCCESS:
      return update(state, {
        tasks: {
          $set: action.tasks
        }
      });
    case actionConsts.ADD_TASK_REQUEST:
      return update(state, {
        tasks: {
          $push: [action.task]
        }
      });
    case actionConsts.ADD_TASK_SUCCESS:
      return update(state, {
        tasks: {
          [state.tasks.length - 1]: {
            id: {
              $set: action.taskId
            }
          }
        }
      });
    case actionConsts.ADD_TASK_FAILURE:
      return update(state, {
        tasks: {
          $splice: [[state.tasks.length - 1, 1]]
        }
      });
    case actionConsts.DELETE_TASK_SUCCESS:
      return update(state, {
        tasks: {
          $splice: [[action.index, 1]]
        }
      });

    case actionConsts.TOGGLE_TASK_IS_CHECKED_REQUEST:
    case actionConsts.TOGGLE_TASK_IS_CHECKED_FAILURE:
      return update(state, {
        tasks: {
          [action.taskIndex]: {
            isChecked: {
              $set: action.isChecked
            }
          }
        }
      });
    case 'KILL_WORKPLACE':
      return initState
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/Tasks/reducer.js